import React, { useState, useEffect } from 'react';
import './Products.css';
import { Link } from 'react-router-dom';

const Products = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);

  // بيانات الفئات
  const categories = [
  { id: 'all', name: 'All' },
  { id: 'herbs', name: 'Herbs' },
  { id: 'seeds', name: 'Seeds' },
  { id: 'spices', name: 'Spices' }
  ];

  // بيانات المنتجات
  useEffect(() => {
    // في التطبيق الحقيقي، قد تأتي هذه البيانات من API
    const productsData = [
  {
    "id": 1,
    "name": "Marjoram",
    "scientificName": "Origanum majorana",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/MARJORAM-480x360.jpeg",
    "forms": ["Dried Leaves", "Whole"],
    "pesticides": ["Organic", "Chemical Free"]
  },
  {
    "id": 2,
    "name": "Basil",
    "scientificName": "Ocimum basilicum",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Dried-Basil-Leaves-480x360.jpg",
    "forms": ["Dried Leaves", "Whole"],
    "pesticides": ["Natural", "No Additives"]
  },
  {
    "id": 3,
    "name": "Hibiscus T.B.C",
    "scientificName": "Hibiscus sabdariffa",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Hibiscus-TBC-480x360.jpg",
    "forms": ["To Be Confirmed", "Dried Flowers"],
    "pesticides": ["Organic", "Chemical Free"]
  },
  {
    "id": 4,
    "name": "Hibiscus Slices",
    "scientificName": "Hibiscus sabdariffa",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/hibiscus-slices-480x360.jpg",
    "forms": ["Slices", "Dried"],
    "pesticides": ["Natural", "No Preservatives"]
  },
  {
    "id": 5,
    "name": "Hibiscus",
    "scientificName": "Hibiscus sabdariffa",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/enhanced_image-2-480x360.png",
    "forms": ["Whole Flowers", "Dried"],
    "pesticides": ["Organic", "Chemical Free"]
  },
  {
    "id": 6,
    "name": "Peppermint",
    "scientificName": "Mentha piperita",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Peppermint-480x360.jpg",
    "forms": ["Dried Leaves", "Whole"],
    "pesticides": ["Organic", "Natural Farming"]
  },
  {
    "id": 7,
    "name": "Spearmint",
    "scientificName": "Mentha spicata",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/spesarmint_11__15154-480x360.jpg",
    "forms": ["Dried Leaves", "Whole"],
    "pesticides": ["Natural", "Chemical Free"]
  },
  {
    "id": 8,
    "name": "Calendula Flowers",
    "scientificName": "Calendula officinalis",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/enhanced_image.png",
    "forms": ["Dried Flowers", "Whole"],
    "pesticides": ["Organic", "Medicinal Grade"]
  },
  {
    "id": 9,
    "name": "Chamomile",
    "scientificName": "Matricaria chamomilla",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/original_image.png",
    "forms": ["Dried Flowers", "Whole"],
    "pesticides": ["Organic", "Chemical Free"]
  },
  {
    "id": 10,
    "name": "Moringa Tcut Leaves",
    "scientificName": "Moringa oleifera",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/08/Moringa-Tcut-Leaevs-480x360.jpeg",
    "forms": ["Dried Leaves", "Cut"],
    "pesticides": ["Organic", "Chemical Free"]
  },
  {
    "id": 11,
    "name": "Moringa Powder",
    "scientificName": "Moringa oleifera",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/08/moringa-powder-480x360.jpg",
    "forms": ["Powder", "Fine Grind"],
    "pesticides": ["Organic Certified", "EU Standards"]
  },
  {
    "id": 12,
    "name": "Moringa",
    "scientificName": "Moringa oleifera",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Moringa-leaves-480x360.png",
    "forms": ["Whole Leaves", "Dried"],
    "pesticides": ["Natural", "No Additives"]
  },
  {
    "id": 13,
    "name": "Molokhia Crushed",
    "scientificName": "Corchorus olitorius",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/enhanced_image-7-480x360.png",
    "forms": ["Crushed", "Dried"],
    "pesticides": ["Traditional Farming", "Safe for Consumption"]
  },
  {
    "id": 14,
    "name": "Molokhia",
    "scientificName": "Corchorus olitorius",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Molokhia-Leaves-480x360.jpg",
    "forms": ["Whole Leaves", "Fresh Dried"],
    "pesticides": ["Natural", "Chemical Free"]
  },
  {
    "id": 15,
    "name": "Thyme",
    "scientificName": "Thymus vulgaris",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Thyme-480x360.jpg",
    "forms": ["Dried", "Whole"],
    "pesticides": ["Wild Harvested", "Organic"]
  },
  {
    "id": 16,
    "name": "Dill",
    "scientificName": "Anethum graveolens",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/DillTips-480x360.webp",
    "forms": ["Tips", "Dried"],
    "pesticides": ["Conventional", "Food Grade"]
  },
  {
    "id": 17,
    "name": "Parsley Curly",
    "scientificName": "Petroselinum crispum",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/PARSLEY-CURLY-480x360.jpg",
    "forms": ["Curly Leaves", "Dried"],
    "pesticides": ["Natural", "No Preservatives"]
  },
  {
    "id": 18,
    "name": "Parsley",
    "scientificName": "Petroselinum crispum",
    "category": "herbs",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/original_image-5-480x353.png",
    "forms": ["Flat Leaves", "Dried"],
    "pesticides": ["Organic", "Chemical Free"]
  },
  {
    "id": 19,
    "name": "Fenugreek",
    "scientificName": "Trigonella foenum-graecum",
    "category": "seeds",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Fenugreek.jpg",
    "forms": ["Whole Seeds", "Cleaned"],
    "pesticides": ["Conventional", "AS Reg. EC396/2005"]
  },
  {
    "id": 20,
    "name": "White Kidney Beans",
    "scientificName": "Phaseolus vulgaris",
    "category": "seeds",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/White-beans-480x360.webp",
    "forms": ["Whole Beans", "Sorted"],
    "pesticides": ["Food Grade", "EU Standards"]
  },
  {
    "id": 21,
    "name": "Fave Beans",
    "scientificName": "Vicia faba",
    "category": "seeds",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/1581423148_711_489038_favabeanssplit-480x360.jpg",
    "forms": ["Split", "Whole"],
    "pesticides": ["Natural", "No Additives"]
  },
  {
    "id": 22,
    "name": "Coriander Seeds",
    "scientificName": "Coriandrum sativum",
    "category": "seeds",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/CORIANDER-SEEDS-480x300.jpg",
    "forms": ["Whole Seeds", "Crushed"],
    "pesticides": ["Organic", "Chemical Free"]
  },
  {
    "id": 23,
    "name": "Cumin",
    "scientificName": "Cuminum cyminum",
    "category": "seeds",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/يسي-480x300.jpg",
    "forms": ["Whole Seeds", "Ground"],
    "pesticides": ["Conventional", "Food Safety Certified"]
  },
  {
    "id": 24,
    "name": "Sunflower Seeds",
    "scientificName": "Helianthus annuus",
    "category": "seeds",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/compressed_image_new9-480x310.jpg",
    "forms": ["Shelled", "Raw"],
    "pesticides": ["Natural", "No Additives"]
  },
  {
    "id": 25,
    "name": "Black Seeds",
    "scientificName": "Nigella sativa",
    "category": "seeds",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/compressed_image_new8-480x360.jpg",
    "forms": ["Whole Seeds", "Cold Pressed Oil"],
    "pesticides": ["Organic", "Traditional"]
  },
  {
    "id": 26,
    "name": "Caraway",
    "scientificName": "Carum carvi",
    "category": "seeds",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/compressed_image_new7-480x313.jpg",
    "forms": ["Whole Seeds", "Ground"],
    "pesticides": ["Conventional", "Food Grade"]
  },
  {
    "id": 27,
    "name": "Fennel",
    "scientificName": "Foeniculum vulgare",
    "category": "seeds",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/compressed_image_new6-480x360.jpg",
    "forms": ["Whole Seeds", "Powder"],
    "pesticides": ["Organic", "Natural Farming"]
  },
  {
    "id": 28,
    "name": "Dry Garlic",
    "scientificName": "Allium sativum",
    "category": "spices",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/pflanzliches_07-480x360.jpg",
    "forms": ["Flakes", "Powder", "Granules"],
    "pesticides": ["Conventional", "Food Safety Standards"]
  },
  {
    "id": 29,
    "name": "Dry Onion",
    "scientificName": "Allium cepa",
    "category": "spices",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Dry-Onion-480x300.jpg",
    "forms": ["Flakes", "Powder", "Chopped"],
    "pesticides": ["Natural", "No Additives"]
  },
  {
    "id": 30,
    "name": "Orange",
    "scientificName": "Citrus × sinensis",
    "category": "spices",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/pflanzliches_20-480x360.jpg",
    "forms": ["Peel", "Powder", "Essential Oil"],
    "pesticides": ["Organic", "Chemical Free"]
  },
  {
    "id": 31,
    "name": "Black Pepper",
    "scientificName": "Piper nigrum",
    "category": "spices",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Black-Pepper-480x300.jpg",
    "forms": ["Whole Peppercorns", "Ground"],
    "pesticides": ["Conventional", "ASTA Quality"]
  },
  {
    "id": 32,
    "name": "Paprika",
    "scientificName": "Capsicum annuum",
    "category": "spices",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Paprika-480x300.jpg",
    "forms": ["Powder", "Flakes"],
    "pesticides": ["Natural", "No Artificial Color"]
  },
  {
    "id": 33,
    "name": "Chili",
    "scientificName": "Capsicum frutescens",
    "category": "spices",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/Chili-480x300.jpg",
    "forms": ["Whole", "Flakes", "Powder"],
    "pesticides": ["Conventional", "Food Grade"]
  },
  {
    "id": 34,
    "name": "Bay Leaf",
    "scientificName": "Laurus nobilis",
    "category": "spices",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/BAY-LEAF-480x300.jpg",
    "forms": ["Whole Leaves", "Crushed"],
    "pesticides": ["Wild Harvested", "Organic"]
  },
  {
    "id": 35,
    "name": "Senna",
    "scientificName": "Senna alexandrina",
    "category": "spices",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/SENNA-480x300.jpg",
    "forms": ["Leaves", "Powder"],
    "pesticides": ["Natural", "Medicinal Grade"]
  },
  {
    "id": 36,
    "name": "Rosemary",
    "scientificName": "Rosmarinus officinalis",
    "category": "spices",
    "image": "https://am-herbal.org/wp-content/uploads/2024/07/ROSEMARY-480x300.jpg",
    "forms": ["Dried Leaves", "Powder"],
    "pesticides": ["Organic", "Chemical Free"]
  }
    ];

    setProducts(productsData);
    setFilteredProducts(productsData);
  }, []);

  // تصفية المنتجات حسب الفئة
  useEffect(() => {
    if (activeCategory === 'all') {
      setFilteredProducts(products);
    } else {
      const filtered = products.filter(product => product.category === activeCategory);
      setFilteredProducts(filtered);
    }
  }, [activeCategory, products]);

  const handleCategoryClick = (categoryId) => {
    setActiveCategory(categoryId);
  };

  return (
    <div className="products-page">
      {/* الهيدر */}
      <header className="products-header">
        <div className="header-content">
          <div className="container">
            <h1 className="animated-headline">
              <span className="headline-text">Our Products</span>
            </h1>
          </div>
        </div>
      </header>

      {/* قسم الفلاتر */}
      <section className="filters-section">
        <div className="container">
          <div className="filters-container">
            {categories.map(category => (
              <button
                key={category.id}
                className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => handleCategoryClick(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* قسم المنتجات */}
      <section className="products-section">
        <div className="container">
          <div className="products-grid">
            {filteredProducts.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>


    </div>
  );
};

// مكون بطاقة المنتج
const ProductCard = ({ product }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  return (
    <div className={`product-card ${isFlipped ? 'flipped' : ''}`} onClick={handleFlip}>
      <div className="card-inner">
        {/* الوجه الأمامي */}
        <div className="card-front">
          <div className="card-image" style={{ backgroundImage: `url(${product.image})` }}></div>
          <div className="card-content">
            <h3 className="product-name">{product.name}</h3>
            <p className="scientific-name">({product.scientificName})</p>
          </div>
        </div>

        {/* الوجه الخلفي */}
        <div className="card-back">
          <div className="card-image" style={{ backgroundImage: `url(${product.image})` }}></div>
          <div className="card-content">
            <h3 className="product-name">{product.name}</h3>
            <p className="scientific-name">{product.scientificName}</p>
            
            <div className="product-details">
              <div className="detail-section">
                <p className="detail-title">Available Supplying Forms</p>
                <ul className="detail-list">
                  {product.forms.map((form, index) => (
                    <li key={index}>{form}</li>
                  ))}
                </ul>
              </div>
              
              <div className="detail-section">
                <p className="detail-title">Pesticides Status</p>
                <ul className="detail-list">
                  {product.pesticides.map((pesticide, index) => (
                    <li key={index}>{pesticide}</li>
                  ))}
                </ul>
              </div>
            </div>
            
            <Link to="/contact" className="inquiry-btn">Contact for Inquiry</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;